import type { RootState } from "../store"

export const billerGroupsSelector = (state: RootState) => state.billerGroups
